<template>
  <a-modal
    title="选择机器人"
    :width="900"
    :visible="visible"
    @cancel="handleCancel"
    :bodyStyle="{}"
    :maskClosable="false"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="查询类型">
              <a-select v-model="queryParam.type" placeholder="请选择查询类型" allowClear>
                <a-select-option value="1">机器人子账户</a-select-option>
                <a-select-option value="2">微信ID</a-select-option>
                <a-select-option value="3">微信昵称</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="请先选择查询类型" />
            </a-form-item>
          </a-col>
          <template v-if="advanced"></template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      v-if="visible"
      ref="table"
      rowKey="id"
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :scroll="{ x: 900 }"
    >
      <span slot="avatar" slot-scope="text, record">
        <a-avatar shape="square" icon="user" :src="record.wx_avatar" />
      </span>
      <span slot="nickname" slot-scope="text">
        <a v-if="!text.nickname">未设置</a>
        <span v-else>{{text.nickname}}</span>
      </span>
      <span slot="get_ecc_project" slot-scope="text,record">
        <a-badge
          v-if="record.get_ecc_project && record.get_ecc_project.project_url"
          status="success"
          text="已加入"
        />
        <a-badge v-else-if="record.get_ecc_project" status="processing" text="待审核" />
        <a-badge v-else status="default" text="未加入" />
      </span>
    </s-table>
    <template slot="footer">
      <span :style="{marginRight:'10px'}">
        <a-checkbox v-model="isReadAgreement"></a-checkbox>
        <span>
          同意
          <a @click="handleAgreement">《ECC服务协议》</a>
        </span>
      </span>
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSubmit" :disabled="!isReadAgreement">确定加入</a-button>
    </template>
  </a-modal>
</template>

<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: 80
  },
  {
    title: '头像',
    scopedSlots: { customRender: 'avatar' },
    width: 80
  },
  {
    title: '微信昵称',
    scopedSlots: { customRender: 'nickname' }
  },
  {
    title: '微信ID',
    dataIndex: 'wx_id'
  },
  {
    title: '是否加入ECC',
    scopedSlots: { customRender: 'get_ecc_project' }
  }
]
import DeviceApi from '@/api/device'
import { STable } from '@/components'
import Vue from 'vue'
export default {
  components: {
    STable
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      columns,
      loading: false,
      visible: false,
      currentRobotId: null,
      isReadAgreement: false,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return DeviceApi.getList(Object.assign(parameter, this.queryParam))
      },
      options: {
        alert: {
          show: true,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange,
          getCheckboxProps: record => ({
            props: {
              disabled: record.get_ecc_project ? true : false
            }
          })
        }
      }
    }
  },
  watch: {
    isReadAgreement(val) {
      Vue.ls.set('eccReadAgreement',val)
    }
  },
  created() {
    this.$nextTick(()=>{
      this.isReadAgreement = Vue.ls.get('eccReadAgreement')
    })
  },
  methods: {
    show() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleSubmit() {
      const list = this.selectedRows
      if(list.length < 1){
        this.$message.info('请选择机器人');
        return false
      }
      this.$emit('change', list)
      this.handleCancel()
    },
    handleAgreement() {
      this.$info({
        title: '请先阅读《ECC服务协议》',
        width: 800,
        closable: true,
        footer: null,
        content: {
          tag: 'div',
          children: [
            {
              tag: 'p',
              text:
                'ECC经济体是北京艾迪时代网络科技有限公司旗下的淘客资本化平台。淘客在加入ECC经济体之前，应仔细阅读本服务协议，并同意遵守本服务协议后方可加入ECC经济体。加入后，淘客与ECC之间自动形成协议关系，本协议可由ECC随时更新，ECC的通知、公告、声明或其它类似内容是本协议的一部分。'
            },
            {
              tag: 'p',
              data: {
                style: {
                  whiteSpace: 'pre-line'
                }
              },
              text: `1. 名词解释
1.1 淘客：电商平台（不限于淘宝、天猫、京东、拼多多）的CPS推广者统称为淘客。
1.2 ECC经济体（简称ECC）：为淘客提供资本化服务。淘客加入ECC后，ECC会根据淘客的实际业绩数据情况，进行并购定价，完成对淘客的资本化并购。
1.3 用户：淘客返利业务（不限于APP、微信号、微信公号等形态）所触达的的终端使用者。

2. 服务内容
2.1 同步业务数据：念初返利软件系统已与ECC系统完成了数据互通对接，淘客申请加入ECC经济体，即代表同意ECC系统定时同步淘客在念初返利软件内的业务数据。
2.2 ECC会根据淘客一段时间内的业务数据情况，对淘客业务进行估值测算，并给出并购价格，双方对于并购价格达成一致，即签署正式的并购协议。
2.3 为用户免费发放ECC的生态奖励：ECC系统会嵌入到淘客的返利业务（APP、微信号、微信公号）前端，基于用户的订单贡献、推广贡献，为用户发放ECC token（生态积分）作为奖励。以此提高用户的黏性，同时将资本收益共享给用户。
2.4 如双方终止合作，淘客可以选择退出ECC经济体，ECC系统会删除该淘客已同步的全部数据。

3. 隐私保护
3.1 在双方没有正式签署并购协议前，ECC对于淘客业务数据的用途，仅限于业绩统计，核算并购价格。不做其它任何商业用途。
3.2 在双方正式签署并购协议后，ECC有权对淘宝的业务数据进行合法的商业价值开发。

4. 责任声明
4.1 ECC无法保证网络服务一定能满足用户的要求，也不保证网络服务的及时性、安全性、准确性。
4.2 对于因不可抗力或ECC不能控制的原因造成的网络服务中断或其它缺陷，ECC不承担责任，但将尽力减少因此而给用户造成的损失和影响。
4.3 对于ECC向用户免费提供的各项网络服务，以及ECC向用户赠送的任何产品或者服务，质量缺陷本身及其引发的任何损失，ECC无需承担任何责任。

5. 附则
5.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。
5.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。
5.3 本协议最终解释权及修订权归北京艾迪时代网络科技有限公司所有。
`
            }
          ]
        },
        okText: '阅读完毕'
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
